<template>
  <div :class="['tinymce-editor', disabled ? 'disabled' : '']">
    <editor
      ref="editor"
      :value="value || ''"
      @input="emitVal"
      :init="editorInit"
      :disabled="disabled"
      :key="componentKey"
      persistent
      :retain-focus="false"
      eager
    ></editor>
    <file-preview ref="filePreview"></file-preview>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce"
import Editor from "@tinymce/tinymce-vue"
import "tinymce/themes/silver"
import "tinymce/plugins/fullscreen"
import "tinymce/plugins/link"
import "tinymce/plugins/autoresize"
import "tinymce/plugins/paste"
import "tinymce/icons/default"
import { tinyImagesUpload } from "@/components/Tinymce/fun"
import FilePreview from "@/components/BaseComponents/FilePreview"
import { randomString } from "@/utils/common"

let curEditor

export default {
  name: "rich",
  components: {
    FilePreview,
    Editor
  },
  props: {
    value: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$on("force-update", this.forceUpdate)
  },
  data() {
    let vue = this
    return {
      componentKey: 0,
      editorInit: {
        paste_data_images: true,
        statusbar: false,
        language_url: `/tinymce/langs/zh_CN.js`,
        language: "zh_CN",
        skin_url: `/tinymce/skins/ui/oxide`,
        content_css: `/tinymce/skins/content/default/content.css, /tinymce/skins/content/default/control.css`,
        icons_url: `/tinymce/skins/content/default/custom/icons.js`,
        icons: "rich",
        max_height: 250,
        autoresize_overflow_padding: 5,
        plugins: "fullscreen image table lineheight paste lists link",
        toolbar:
          "fullscreen forecolor bold italic | underline strikethrough backcolor | link alignleft aligncenter alignright alignjustify outdent indent styleselect formatselect fontselect fontsizeselect bullist numlist table image lineheight",
        fontsize_formats: "12px 14px 16px 18px 24px 36px 48px 56px 72px",
        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats;",
        branding: false,
        resize: false,
        menubar: "",
        toolbar_mode: "floating",
        images_reuse_filename: true, // 允许复用文件名称
        images_upload_handler: this.imagesUploadHandler,
        setup: function(editor) {
          curEditor = editor
          editor.on("click", function(e) {
            if (e.target.tagName === "IMG") {
              let fileInfo = {
                url: e.target.src,
                type: "img",
                name: ""
              }
              vue.$refs.filePreview.preview(fileInfo)
            }
          })
          editor.on("FullscreenStateChanged", function(state) {
            vue.$emit("fullscreenStateChanged", state.state)
          })
        }
      }
    }
  },
  methods: {
    forceUpdate() {
      this.componentKey = randomString(6)
    },
    imagesUploadHandler(blobInfo, success, failure) {
      tinyImagesUpload(blobInfo, success, failure).then(() => {
        // 设置图片默认大小
        let regex = new RegExp("<img src=", "gi")
        this.emitVal(
          tinymce.activeEditor
            .getContent()
            .replace(regex, `<img style="width: 300px; display: inline-block;" src=`)
        )
      })
    },
    emitVal(val) {
      this.$emit("input", val)
    },
    closeDrawer() {
      let curState = curEditor?.queryCommandState("ToggleToolbarDrawer")
      if (curState) curEditor?.execCommand("ToggleToolbarDrawer")
    }
  }
}
</script>
<style lang="scss" scoped>
.tinymce-editor {
  ::v-deep .bold-svg {
    font-size: 18px;
  }
  &.disabled {
    ::v-deep {
      iframe {
        background: #f6f7fa;
      }
    }
  }
}
</style>
